import * as React from "react"
import { Helmet } from "react-helmet"

const seoURL = (path: string) => {
	const url = process.env.RAZZLE_BASE_URL!

	if (url.endsWith("/") && path.startsWith("/"))
		return process.env.RAZZLE_BASE_URL + path.slice(1)

	if (!url.endsWith("/") && !path.startsWith("/"))
		return process.env.RAZZLE_BASE_URL + "/" + path

	return process.env.RAZZLE_BASE_URL + path
}

const WebSiteName = "مرجع آنتی ویروس ایران"

const getMetaTags = ({
	title,
	description,
	url,
	contentType,
	keywords,
	published,
	updated,
	category,
	tags,
	image,
	amount,
	currency,
	robots,
	author,
}: MetaTags & { url: string }) => {
	const metaTags = [
		{ name: "description", content: description },
		// { name: "twitter:card", content: "summary_large_image" },
		// { name: "twitter:site", content: "@themeteorchef" },
		// { name: "twitter:title", content: `${title} | The Meteor Chef` },
		// { name: "twitter:description", content: description },
		// { name: "twitter:creator", content: `@${twitter}` || "@themeteorchef" },
		// { name: "twitter:image:src", content: seoImageURL(_.sample(seoImages.twitter)) },
		{ name: "og:title", content: `${title} | ${WebSiteName}` },
		{ name: "og:type", content: contentType },
		{ name: "og:locale", content: "fa_IR" },
		{ name: "og:url", content: url },
		{ name: "og:image", content: image },
		{ name: "og:description", content: description },
		{ name: "og:site_name", content: WebSiteName },
		{ name: "keywords", content: keywords },
		{ name: "robots", content: robots },
	]

	if (published)
		metaTags.push({ name: "article:published_time", content: published })
	if (updated)
		metaTags.push({ name: "article:modified_time", content: updated })
	if (category) metaTags.push({ name: "article:section", content: category })
	if (Array.isArray(tags) && tags.length !== 0) {
		tags.forEach((tag) => {
			metaTags.push({ name: "article:tag", content: tag })
		})
	}
	if (amount) metaTags.push({ name: "og:price:amount", content: amount })
	if (currency)
		metaTags.push({ name: "og:price:currency", content: currency })
	if (author) metaTags.push({ name: "author", content: author })

	return metaTags
}

interface MetaTags {
	title: string
	description: string
	contentType?: string
	keywords?: string
	published?: string
	updated?: string
	category?: string
	tags?: string[]
	image?: string
	amount?: string
	currency?: string
	twitter?: string
	robots?: string
	author?: string
}

interface Seo extends MetaTags {
	path: string
}

const Seo: React.FC<Seo> = ({
	title,
	description,
	path,
	contentType = "website",
	keywords,
	published,
	updated,
	category,
	tags = [],
	image = "logo.png",
	amount,
	currency,
	twitter,
	robots = "index,follow",
	author,
}) => {
	return (
		<Helmet
			htmlAttributes={{
				lang: "fa",
			}}
			bodyAttributes={{
				dir: "rtl",
			}}
			title={`${title} | ${WebSiteName}`}
			link={[{ rel: "canonical", href: seoURL(path) }]}
			meta={getMetaTags({
				title,
				description,
				contentType,
				url: seoURL(path),
				image: image.startsWith("https") ? image : seoURL(image),
				published,
				updated,
				category,
				tags,
				twitter,
				keywords,
				amount,
				currency,
				robots,
				author,
			})}
		/>
	)
}

export default Seo
